import { InvoiceFilter } from '../financials/types'
import { RootStoreState } from '../root'

export const invoiceFiltersSelector = (state: RootStoreState): ReadonlyArray<InvoiceFilter> => state.financials.invoiceFilters